module.exports = __webpack_public_path__ + "static/img/10.b05459b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/10.png
// module id = lcMk
// module chunks = 0